document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("cart")) return;
  const discountCodeForm = document.querySelector("#cart-discount-form");
  const discountCodeFormSubmit = document.querySelector(
    "#cart-discount-form-submit"
  );
  const discountCodeInput = document.querySelector("#discount-code-input");

  // Request data from the server. Throw a labeled error if it fails.
  const fetchOrShowError = async (label, url) => {
    const localeAwareUrl = window.Shopify.routes.root + url;
    const response = await fetch(localeAwareUrl);
    if (!response.ok) {
      throw new Error(
        `${label} failed: ${response.status} ${response.statusText}`
      );
    }
    return response;
  };

  // New helper for applying discounts via update.js
  const applyDiscount = async (code) => {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: code }),
      }
    );
    if (!response.ok) {
      throw new Error(
        `Discount application failed: ${response.status} ${response.statusText}`
      );
    }
    return response;
  };

  // Check the cart to see if a specific discount code has been applied.
  const checkForDiscount = (cart, code) => {
    // Check for order-level discounts
    if (
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.some((app) => app.title === code)
    ) {
      return true;
    }

    // Check for line item discounts
    if (
      cart.items.some((item) =>
        item.discounts?.some((discount) => discount.title === code)
      )
    ) {
      return true;
    }

    return false;
  };

  // Intercept the form being submitted and apply the discount code.
  discountCodeFormSubmit.addEventListener("click", async (e) => {
    e.preventDefault();

    // Field must not be empty
    const code = discountCodeInput.value.trim();
    if (!code) {
      return;
    }

    try {
      await applyDiscount(code);

      // Check if the discount was actually applied instead just assuming it
      // succeeded.
      const cartResponse = await fetchOrShowError("Cart fetch", "cart.js");
      const cart = await cartResponse.json();

      if (checkForDiscount(cart, code)) {
        location.reload();
      }
    } catch (e) {
      // No messaging
    }
  });

  let header = document.querySelector(".main-header");
  let headerHeight = header.offsetHeight;
  const cartSummary = document.querySelector(".cart-summary");
  console.log(cartSummary);

  if (cartSummary) {
    cartSummary.style.position = "sticky";
    cartSummary.style.top = headerHeight + "px";

    document.addEventListener("scroll", (event) => {
      let headerHeight = header.offsetHeight + 12;
      cartSummary.style.top = headerHeight + "px";

      const body = document.querySelector("body");
      if (!body.classList.contains("scrolled-down")) {
        cartSummary.style.top = headerHeight + 44 + "px";
      }
    });
  }

  const wptCartProducts = document.querySelectorAll("wpt-cart-product");

  if (wptCartProducts) {
    const timeRemaining = localStorage.getItem("timeRemaining");

    if (timeRemaining) {
      const countdownDate = new Date(timeRemaining).getTime();
      const countdownInterval = setInterval(function () {
        const now = new Date().getTime();
        const future = countdownDate - now;
        const minutes = Math.floor((future % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((future % (1000 * 60)) / 1000);
        const countdownElement = document.querySelector(".js-cart-countdown");
        if (countdownElement) {
          countdownElement.innerHTML = `
          ${minutes}:${seconds} minutes. 
          `;
        }
        if (future < 0) {
          clearInterval(countdownInterval);
          if (countdownElement) {
            countdownElement.innerHTML =
              "Your time has expired. All workplace training courses have been removed from your basket.";
            wptCartProducts.forEach((product) => {
              const productID = product.getAttribute("data-product-id");
              const body = {
                id: productID,
                quantity: 0,
                properties: {
                  _attendeeDetails: JSON.stringify([]),
                },
              };
              window.liquidAjaxCart.change(body);
            });
          }
        }
      }, 1000);
    } else {
      console.error("No countdown time found in local storage.");
    }
    checkDetailsComplete();
  }
});

class WPTCartProduct extends HTMLElement {
  constructor() {
    super();

    this.clickableHeader = this.querySelector(".js-cart-accordion-header");
    this.accordion = this.querySelector(".js-cart-accordion");
    this.cartCourseAccordions = document.querySelectorAll("wpt-cart-product");
    this.courseID = this.getAttribute("data-product-id");
    this.saveButton = this.querySelector(".js-save-attendees");
    this.removeButtons = this.querySelectorAll(".js-remove-attendee");
    this.addButton = this.querySelector(".js-add-attendee");
    this.attendeeDetails = this.querySelectorAll(".js-attendee-detail");
    this.populatedAttendees = this.querySelector(".js-populated-attendees");
    this.plusButton = this.querySelector(".js-quantity-plus");
    this.minusButton = this.querySelector(".js-quantity-minus");
    this.quantityInput = this.querySelector(".js-quantity-input");
    let lineItemProperties = this.getAttribute("data-line-item-properties");
    try {
      this.currentLineItemProperties = lineItemProperties
        ? typeof lineItemProperties === "string"
          ? JSON.parse(lineItemProperties.replace(/'/g, '"'))
          : lineItemProperties
        : {};
    } catch (e) {
      this.currentLineItemProperties = {};
    }

    this.init();
  }

  init() {
    //check for local storage
    const localStorageKey = `attendeeDetails-${this.courseID}`;
    const storedAttendeeDetails = localStorage.getItem(localStorageKey);
    if (storedAttendeeDetails) {
      const parsedDetails = JSON.parse(storedAttendeeDetails);
      this.attendeeDetails.forEach((detail, index) => {
        if (parsedDetails[index]) {
          let firstNameData = `delegate_${index + 1}_first_name`;
          let lastNameData = `delegate_${index + 1}_last_name`;
          let emailData = `delegate_${index + 1}_email`;
          let phoneData = `delegate_${index + 1}_phone`;

          detail.querySelector(".js-attendee-detail-first-name").value =
            parsedDetails[index][firstNameData] || "";
          detail.querySelector(".js-attendee-detail-last-name").value =
            parsedDetails[index][lastNameData] || "";
          detail.querySelector(".js-attendee-detail-email").value =
            parsedDetails[index][emailData] || "";
          detail.querySelector(".js-attendee-detail-phone").value =
            parsedDetails[index][phoneData] || "";
          detail.setAttribute("data-status", "complete");
        }
      });
      //update populated attendees count
      this.populatedAttendees.innerHTML = parsedDetails.length;
    }

    this.clickableHeader.addEventListener("click", (e) => {
      e.preventDefault();
      this.openAccordion(e);
    });
    this.clickableHeader.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.openAccordion(e);
      }
    });

    this.addButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.plusButton.click();
      const elementHeader = this.getBoundingClientRect();
      const elementTop = elementHeader.top + window.scrollY - 150;

      window.scrollTo({
        top: elementTop,
        behavior: "smooth",
      });
    });

    this.removeButtons.forEach((removeButton, index) => {
      removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.removeAttendeeDetail(index);
        const elementHeader = this.getBoundingClientRect();
        const elementTop = elementHeader.top + window.scrollY - 150;
        window.scrollTo({
          top: elementTop,
          behavior: "smooth",
        });
      });
    });

    this.saveButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.saveAttendeeDetails();
      this.clickableHeader.click();
      this.checkAttendeeDetails();
    });

    this.saveButton.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.saveAttendeeDetails();
        this.clickableHeader.click();
      }
    });

    this.checkAttendeeDetails();
  }

  openAccordion(e) {
    const content = this.accordion.querySelector(".js-cart-accordion-inner");
    const chevron = this.accordion.querySelector(".chevron");
    const isActive = content.classList.contains("active");

    // Toggle the clicked accordion
    if (!isActive) {
      content.classList.add("active");
      chevron.classList.add("active");
      this.accordion.setAttribute("aria-expanded", "true");
      const index = Array.from(this.cartCourseAccordions).indexOf(this) + 1;
      if (index !== 0) {
        document.body.classList.add(`cart-accordion-open-${index}`);
      }
    } else {
      content.classList.remove("active");
      chevron.classList.remove("active");
      this.accordion.setAttribute("aria-expanded", "false");
      const index = Array.from(this.cartCourseAccordions).indexOf(this) + 1;
      if (index !== 0) {
        document.body.classList.remove(`cart-accordion-open-${index}`);
      }
    }
  }

  removeAttendeeDetail(index) {
    // Remove the attendee detail at the specified index
    const attendeeDetails = this.accordion.querySelectorAll(
      ".js-attendee-detail"
    );
    if (attendeeDetails[index]) {
      attendeeDetails[index].remove();
    } else {
      console.error("No attendee detail found at index:", index);
    }

    // Update the attendee details count in dropdown header
    const updatedAttendeeDetails = this.accordion.querySelectorAll(
      ".js-attendee-detail"
    );
    const attendeeQuantity = this.accordion.querySelector(".js-attendees-qty");
    attendeeQuantity.textContent = updatedAttendeeDetails.length;

    // Update the attendee detail numbers
    updatedAttendeeDetails.forEach((detail, idx) => {
      const attendeeNumber = idx + 1;
      detail.querySelector("span").textContent = `Attendee ${attendeeNumber}:`;
    });

    // Change the quantity
    const currentQty = this.accordion.getAttribute("data-current-qty");
    const newQty = currentQty - 1;
    this.accordion.setAttribute("data-current-qty", newQty);

    // Update the cart with new quantity
    const body = {
      id: this.courseID,
      quantity: newQty,
      properties: {
        _attendeeDetails: JSON.stringify([]), // Clear attendee details
      },
    };

    window.liquidAjaxCart.change(body);

    const elementHeader = this.getBoundingClientRect();
    const elementTop = elementHeader.top + window.scrollY - 150;
    window.scrollTo({
      top: elementTop,
      behavior: "smooth",
    });
  }

  checkAttendeeDetails() {
    let completedDetails = Array.from(this.attendeeDetails).filter(
      (detail) => detail.getAttribute("data-status") === "complete"
    ).length;
    //get the overall status of attendee details
    if (completedDetails === this.attendeeDetails.length) {
      this.setAttribute("data-details-complete", "true");
    } else {
      this.setAttribute("data-details-complete", "false");
    }
  }

  saveAttendeeDetails() {
    const currentQty = this.accordion.getAttribute("data-current-qty");

    const attendeeDetailsArray = [];
    const attendeeProperties = {};

    this.attendeeDetails.forEach((detail, idx) => {
      const detailName = detail.querySelector(
        ".js-attendee-detail-first-name"
      ).value;
      const detailLastName = detail.querySelector(
        ".js-attendee-detail-last-name"
      ).value;
      const detailEmail = detail.querySelector(
        ".js-attendee-detail-email"
      ).value;
      const detailPhone = detail.querySelector(
        ".js-attendee-detail-phone"
      ).value;

      // Check if all fields are filled
      if (detailName && detailLastName && detailEmail) {
        detail.setAttribute("data-status", "complete");

        attendeeDetailsArray.push({
          [`delegate_${idx + 1}_first_name`]: detailName.trim(),
          [`delegate_${idx + 1}_last_name`]: detailLastName.trim(),
          [`delegate_${idx + 1}_email`]: detailEmail.trim(),
          [`delegate_${idx + 1}_phone`]: detailPhone ? detailPhone.trim() : "",
        });

        attendeeProperties[`delegate_${idx + 1}_first_name`] =
          detailName.trim();
        attendeeProperties[`delegate_${idx + 1}_last_name`] =
          detailLastName.trim();
        attendeeProperties[`delegate_${idx + 1}_email`] = detailEmail.trim();
        attendeeProperties[`delegate_${idx + 1}_phone`] = detailPhone
          ? detailPhone.trim()
          : "";
      } else {
        detail.setAttribute("data-status", "incomplete");
      }
    });

    localStorage.setItem(
      `attendeeDetails-${this.courseID}`,
      JSON.stringify(attendeeDetailsArray)
    );

    const body = {
      id: this.courseID,
      quantity: currentQty,
      properties: {
        ...this.currentLineItemProperties,
        ...attendeeProperties,
      },
    };
    window.liquidAjaxCart.change(body);
    // Update number of populated attendee details in dropdown header
    this.populatedAttendees.innerHTML = attendeeDetailsArray.length;
    const elementHeader = this.getBoundingClientRect();
    const elementTop = elementHeader.top + window.scrollY - 150;
    window.scrollTo({
      top: elementTop,
      behavior: "smooth",
    });
  }
}

customElements.define("wpt-cart-product", WPTCartProduct);

document.addEventListener("liquid-ajax-cart:request-start", function (event) {
  const submitButton =
    event.target?.activeElement?.querySelector("[type='submit']");
  if (submitButton) {
    const spinner = submitButton.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.remove("hidden");
    submitButton.classList.add("loading");
  }
  // Check if there are any WPT Cart Products
  const wptCartProducts = document.querySelectorAll("wpt-cart-product");
  if (wptCartProducts.length > 0 && wptCartProducts) {
    checkDetailsComplete();
  }
});

document.addEventListener("liquid-ajax-cart:request-end", function (event) {
  const submitButton =
    event.detail?.requestState?.info?.initiator?.querySelector(
      "[type='submit']"
    );

  // If the "add to cart" request is successful
  if (
    event.detail.requestState.requestType === "add" &&
    event.detail.requestState.responseData?.ok
  ) {
    if (submitButton) {
      const textSpan = submitButton.querySelector(".submit-text");
      const spinner = submitButton.querySelector(".loading-overlay__spinner");
      if (spinner) spinner.classList.add("hidden");
      submitButton.classList.remove("loading");
      submitButton.classList.add("added");
      if (textSpan) {
        textSpan.innerText =
          window.Moonbase.locales.products.product.added_to_cart || "Added";
        setTimeout(() => {
          textSpan.innerText =
            window.Moonbase.locales.products.product.add_to_cart || "Add to cart";
          submitButton.classList.remove("added");
        }, 3000);
      }
    }
  }
  // Check if there are any WPT Cart Products
  const wptCartProducts = document.querySelectorAll("wpt-cart-product");
  if (wptCartProducts.length > 0 && wptCartProducts) {
    checkDetailsComplete();
  }
});

function checkDetailsComplete() {
  const checkoutButton = document.querySelector(".js-cart-checkout-button");
  const checkoutAlert = document.querySelector(".js-cart-checkout-alert");
  const wptCartProducts = document.querySelectorAll("wpt-cart-product");

  let detailsCount = wptCartProducts.length;
  let detailsCompleteCount = 0;

  //if all wpt products have data-details-complete set to true, then enable checkout button
  wptCartProducts.forEach((product) => {
    if (product.getAttribute("data-details-complete") === "true") {
      detailsCompleteCount++;
    }
  });

  //if all products have data-details-complete set to true, then enable checkout button
  if (checkoutButton) {
    if (detailsCompleteCount === detailsCount) {
      checkoutButton.classList.remove("wpt-disabled");
      checkoutAlert.classList.remove("wpt-disabled");
    } else {
      checkoutAlert.classList.add("wpt-disabled");
      checkoutButton.classList.add("wpt-disabled");
    }
  }
}

//if you click the checkout button with the disabled class
const checkoutButton = document.querySelector(".js-cart-checkout-button");

if (checkoutButton) {
  checkoutButton.addEventListener("click", (e) => {
    if (e.target.classList.contains("wpt-disabled")) {
      document.body.classList.add("clicked");
    }
  });
}
